import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/'
import index from '@/components/page/index'
import moreFunction from '@/components/page/moreFunction'
import login from '@/components/page/login'
import search from '@/components/page/search'
import fangT from '@/components/page/fangT'
import fangQ from '@/components/page/fangQ'
import fangQList from '@/components/page/fangQList'
import fangXQ from '@/components/page/fangXQ'
import book from '@/components/page/book/book'
import fangTXQ from '@/components/page/fangTXQ/fangTXQ'
import orderList from '@/components/page/orderList'
import orderDetail from '@/components/page/orderDetail'
import repair from '@/components/page/repair'
import cityState from '@/components/page/cityState'

import indexDetail from '@/components/page/indexDetail'
import indexDesc from '@/components/page/indexDesc'
import ConfigeHotel from '@/components/page/ConfigeHotel'
import anypay from '@/components/page/anypay/pay'
import anypayRefundList from '@/components/page/anypay/anypayRefundList'
import anypaySearch from '@/components/page/anypay/anypaySearch'

import IncomeAccount from '@/components/page/fangTXQ/IncomeAccount'
import InsertBill from '@/components/page/fangTXQ/InsertBill'
import addLiveWith from '@/components/page/fangTXQ/addLiveWith'

// 各个路由module
import infoRoute from './modules/info'
import userCenterRoute from './modules/userCenter'
import reportRoute from './modules/report'
import meetingRoute from './modules/meeting'
import memberRoute from './modules/member'
import discoverRoute from './modules/discover'
import mobileOrderRouter from './modules/mobileOrderRouter'
import cateringRouter from './modules/catering'

// opera的路由
import operaRouter from './operaRouter'
import huanQiuRouter from './huanQiuRouter'

Vue.use(Router)

Router.prototype.goBack = function () {
  this.isBack = true
  window.history.go(-1)
}

let basicRoute = [{
  path: '/',
  name: 'index',
  component: index
},
  {
    path: '/moreFunction',
    name: 'moreFunction',
    component: moreFunction
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/search',
    name: 'search',
    component: search
  },
  {
    path: '/fangT',
    name: 'fangT',
    component: fangT
  },
  {
    path: '/fangQ',
    name: 'fangQ',
    component: fangQ
  },{
    path: '/fangQList',
    name: 'fangQList',
    component: fangQList
  },
  {
    path: '/fangXQ',
    name: 'fangXQ',
    component: fangXQ
  },
  {
    path: '/book',
    name: 'book',
    component: book
  },
  {
    path: '/fangTXQ',
    name: 'fangTXQ',
    component: fangTXQ
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: orderList
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: orderDetail
  },
  {
    path: '/repair',
    name: 'repair',
    component: repair
  },
  {
    path: '/cityState',
    name: 'cityState',
    component: cityState
  },

  {
    path: '/indexDetail',
    name: 'indexDetail',
    component: indexDetail
  },
  {
    path: '/indexDesc',
    name: 'indexDesc',
    component: indexDesc
  },
  {
    path: '/ConfigeHotel',
    name: 'ConfigeHotel',
    component: ConfigeHotel
  },

  {
    path: '/anypay/anypay',
    name: 'anypay',
    component: anypay
  },
  {
    path: '/anypay/RefundList',
    name: 'anypayRefundList',
    component: anypayRefundList
  },
  {
    path: '/anypay/Search',
    name: 'anypaySearch',
    component: anypaySearch
  },

  {
    path: '/ftxq/IncomeAccount',
    name: 'IncomeAccount',
    component: IncomeAccount
  },
  {
    path: '/ftxq/InsertBill',
    name: 'InsertBill',
    component: InsertBill
  },
  {
    path: '/ftxq/scanPay',
    name: 'ScanPay',
    component: () =>
      import ('@/components/page/fangTXQ/scanPay')
  },
  {
    path: '/ftxq/addLiveWith',
    name: 'addLiveWith',
    component: () =>
      import ('@/components/page/fangTXQ/addLiveWith')
  },
  {
    path: '/RmtypeFloor',
    name: 'RmtypeFloor',
    component: () =>
      import ('@/components/page/RmtypeFloor')
  },

  // licheng 页面
  {
    path: '/lichengIndexDetail',
    name: 'lichengIndexDetail',
    component: () =>
      import ('@/components/page/licheng/indexDetail')
  },
  {
    path: '/lichengFangQ',
    name: 'lichengFangQ',
    component: () =>
      import ('@/components/page/licheng/fangQ')
  },
  {
    path: '/lichengFangXQ',
    name: 'lichengFangXQ',
    component: () =>
      import ('@/components/page/licheng/fangXQ')
  },
]

let finalRoute = [
  ...basicRoute,
  ...infoRoute,
  ...userCenterRoute,
  ...reportRoute,
  ...meetingRoute,
  ...memberRoute,
  ...discoverRoute,
  ...mobileOrderRouter,
  ...cateringRouter,
  ...operaRouter,
  ...huanQiuRouter,
]

const router = new Router({
  routes: finalRoute
})

function page(to, from, next) {
  //定义一个可以记录路由路径变化的数组，这里用在vuex，其实也可以用sessionStorage,或者在window.routeChain等变量
  //不一定要用到vuex
  let routeLength = store.state.routeChain.length;
  if (!localStorage.getItem('JWT_TOKEN') && to.name != 'login') {
    if (window.navigator.userAgent.indexOf("Html5Plus") > 0) {
      var A = plus.webview.getLaunchWebview();
      A.evalJS('loginOut(false)');
      return;
    }
    next({
      path: '/Login',
      query: {
        redirect: from.path
      }
    })
  } else {
    if (window.plus) {
      plus.statistic.eventTrig(to.path == "/" ? "home" : to.path.substr(1).replace('/', '_'));
    }

    let tabbarNav = ['/', '/info', '/discoverList', '/center', '/opera/', '/opera/info', '/opera/center']

    let mobileOrderTab = [
      '/mobileOrdering/index',
      '/mobileOrdering/mihotelPreOrder',
      '/mobileOrdering/bill',
      '/mobileOrdering/home'
    ]

    let isMobileOrderTabSwitch = mobileOrderTab.indexOf(to.path) > -1 && mobileOrderTab.indexOf(from.path) > -1
    let isTabSwitch = tabbarNav.indexOf(to.path) > -1 && tabbarNav.indexOf(from.path) > -1
    isTabSwitch = isTabSwitch || isMobileOrderTabSwitch
    console.log('isTabSwitch', isTabSwitch)

    let animate = ''
    if (routeLength === 0) {
      animate = 'fade'
      store.commit('setPageDirection', animate);
      if (to.path === from.path && to.path === '/') {
        //当直接打开根路由的时候
        store.commit('addRouteChain', to);
      } else {
        //直接打开非根路由的时候其实生成了两个路径，from其实就是根路由
        store.commit('addRouteChain', from);
        store.commit('addRouteChain', to);
      }
    } else if (routeLength === 1) {
      animate = isTabSwitch ? 'fade' : 'slide-left'
      store.commit('setPageDirection', animate);
      store.commit('addRouteChain', to);
    } else {
      let lastBeforeRoute = store.state.routeChain[routeLength - 2];
      // opera酒店切换的动画效果
      let backToIndex = (from.path == '/search') && ((to.path == '/opera/') || (to.path == '/'))
      if ((lastBeforeRoute.path === to.path) || backToIndex) {
        animate = isTabSwitch ? 'fade' : 'slide-right'
        store.commit('popRouteChain');
        store.commit('setPageDirection', animate);
      } else {
        animate = isTabSwitch ? 'fade' : 'slide-left'
        store.commit('addRouteChain', to);
        store.commit('setPageDirection', animate);
      }
    }
    next();
  }
}

router.beforeEach((to, from, next) => {
  page(to, from, next);
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js